import axios from "axios";
import { getToken } from "./auth";

const instance = axios.create({
  //baseURL: "http://192.168.169.238:5001/",
  baseURL: "https://jsfideliza.com.br/api/",
});

instance.getError = function (error, _default = "") {
  try {
    const { response } = error;

    const err = response?.data?.error || _default;

    return (
      err ||
      "Houve um erro inesperado no servidor. Contate o administrador do sistema!"
    );
  } catch (e) {
    return (
      _default ||
      "Houve um erro inesperado no servidor. Contate o administrador do sistema!"
    );
  }
};

instance.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers["x-access-token"] = token;
    }

    return config;
  },
  (error) => Promise.reject(error),
);

instance.interceptors.response.use(
  (response) => {
    // ✅ Any 2xx status codes

    return response.data;
  },
  (error) => {
    // ❌ Handle errors
    if (error.response) {
      if (error.response.status === 401) {
        // Example: redirect to login if unauthorized

        window.location.href = window.pageLogin;
      }
      if (error.response.status === 403) {
        alert("Você não tem permissão para acessar esse recurso");
      }

      if (error.response.status === 500) {
        const { error: err } = error.response.data;
        error.message = err;
      }

      if (error.response.status === 400) {
        const { error: err } = error.response.data;
        error.message = err;
      }
    }
    return Promise.reject(error);
  },
);

export default instance;
